export enum StorageKey {
  WORKSPACE_ID = 'WORKSPACE_ID',
  LAST_SESSION_ID = 'LAST_SESSION_ID',
}
